import '../sass/styles.scss';
import 'slick-carousel/slick/slick.js';
import 'dropkickjs/dist/dropkick.js';
import AOS from 'aos/dist/aos.js';
import jarallax from 'jarallax/dist/jarallax.js';


const navigator = document.querySelector("nav");
const navbtn = document.querySelector('.nav-btn');
const close = document.querySelector(".close-menu"); 
const out = document.querySelector("main");

$ = jQuery;

navbtn.addEventListener("click", function(){
    navigator.classList.add('show');
});

close.addEventListener("click", function(){
    navigator.classList.remove('show');
});

out.addEventListener("click", function(){
    navigator.classList.remove('show');
});


const header = document.querySelector("header");

window.addEventListener('scroll', () => (window.scrollY > 200) ? header.classList.add('reduce_header') :  header.classList.remove('reduce_header')  );

window.addEventListener('resize', function(){
    document.querySelector("nav").classList.remove('show');
});

AOS.init({
    once: true,
});

jarallax(document.querySelectorAll('[data-jarallax]'));


$(".slider").slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false
});

$('.slider2').slick({
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4000,
  adaptiveHeight: true
});

$(".historias-capital-humano .left2").click( () => {
$(".slider2").slick('slickPrev');
});

$(".historias-capital-humano .right2").click( () => {
$(".slider2").slick('slickNext');
});

$('.slider3').slick({
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4000,
  adaptiveHeight: true
});

$(".banner-noticias .left3").click( () => {
$(".slider3").slick('slickPrev');
});

$(".banner-noticias .right3").click( () => {
$(".slider3").slick('slickNext');
});


// // ============================================
// // SCROLL HORIZONTAL CON LENIS
// // ============================================
// const lenisScroll = new Lenis({
//     duration: 1.2,
//     easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
//     smooth: true,
//     direction: 'vertical',
//     gestureDirection: 'vertical',
//     smoothTouch: false,
//     touchMultiplier: 2,
// });

// function raf(time) {
//     lenisScroll.raf(time);
//     requestAnimationFrame(raf);
// }
// requestAnimationFrame(raf);

// const scrollContainer = document.querySelector('.scroll-container');
// const scrollContent = document.querySelector('.scroll-content');

// if (scrollContainer && scrollContent) {
//     const getScrollAmount = () => {
//         const scrollWidth = scrollContent.scrollWidth;
//         return -(scrollWidth - window.innerWidth);
//     };

//     const tween = gsap.to(scrollContent, {
//         x: getScrollAmount,
//         duration: 3,
//         ease: "none",
//     });

//     ScrollTrigger.create({
//         trigger: scrollContainer,
//         start: "top top",
//         end: () => `+=${getScrollAmount() * -1}`,
//         pin: true,
//         animation: tween,
//         scrub: 1,
//         invalidateOnRefresh: true,
//         markers: false
//     });

//     window.addEventListener('resize', () => {
//         ScrollTrigger.refresh();
//     });
// }


// ============================================
// SCROLL HORIZONTAL CON LENIS
// ============================================
const lenisScroll = new Lenis({
  duration: 1.5,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  smooth: true,
  direction: 'vertical',
  gestureDirection: 'vertical',
  smoothTouch: false,
  touchMultiplier: 2,
});

function raf(time) {
  lenisScroll.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

const scrollContainer = document.querySelector('.scroll-container');
const scrollContent  = document.querySelector('.scroll-content');

if (scrollContainer && scrollContent) {

  // Primer item que queremos “congelar”
  const firstItem = scrollContent.querySelector('.scroll-item');

  const getScrollAmount = () => {
      const scrollWidth = scrollContent.scrollWidth;
      // volvemos a tu fórmula original
      return -(scrollWidth - window.innerWidth);
  };

  const tween = gsap.to(scrollContent, {
      x: getScrollAmount,
      duration: 5,
      ease: "none",
      onUpdate: () => {
          if (!firstItem) return;
          // x actual del contenedor
          const currentX = gsap.getProperty(scrollContent, "x");
          // movimiento inverso para que el primer item se vea fijo
          gsap.set(firstItem, { x: -currentX });
      }
  });

  ScrollTrigger.create({
      trigger: scrollContainer,
      start: "top top",
      end: () => `+=${getScrollAmount() * -1}`,
      pin: true,
      animation: tween,
      scrub: 1,
      invalidateOnRefresh: true,
      markers: false
  });

  window.addEventListener('resize', () => {
      ScrollTrigger.refresh();
  });
}



document.addEventListener("DOMContentLoaded", () => {
    const counters = document.querySelectorAll(".counter-item h4");
  
    const animateCounter = (el, target, suffix = "", duration = 4500) => {
      let startTimestamp = null;
      const startValue = 0;
  
      // Easing suave
      const easeOutQuad = t => t * (2 - t);
  
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const eased = easeOutQuad(progress);
        const value = startValue + (target - startValue) * eased;
  
        // Si es entero, sin decimales. Si tiene decimales, uno solo.
        if (Number.isInteger(target)) {
          el.textContent = Math.floor(value) + suffix;
        } else {
          el.textContent = value.toFixed(1) + suffix;
        }
  
        if (progress < 1) {
          requestAnimationFrame(step);
        }
      };
  
      requestAnimationFrame(step);
    };
  
    // Solo disparar animación cuando el elemento se vea
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const text = el.textContent.trim();
  
          // Separar número y sufijo: "99.5%" -> ["99.5", "%"]
          const match = text.match(/^([\d.,]+)(.*)$/);
          if (!match) return;
  
          let numberPart = match[1];
          const suffix = match[2] || "";
  
          // Normalizar: quitar separador de miles y usar punto como decimal
        //   numberPart = numberPart.replace(/\./g, "").replace(",", ".");
          numberPart = numberPart.replace(",", ".");

          const target = parseFloat(numberPart);
  
          if (!isNaN(target)) {
            animateCounter(el, target, suffix);
          }
  
          obs.unobserve(el); // para que solo se anime una vez
        }
      });
    }, {
      threshold: 0.5
    });
  
    counters.forEach(counter => observer.observe(counter));
});



// (function(){
//   const input = document.getElementById('productSearch');
//   const clearBtn = document.getElementById('clearSearch');
//   const azBtns = Array.from(document.querySelectorAll('.az-btn'));

//   const grid = document.getElementById('productsGrid');
//   const cards = Array.from(grid.querySelectorAll('.product-card'));

//   const noResults = document.getElementById('noResults');
//   const resultsCount = document.getElementById('resultsCount');

//   // Sección de abajo (la lista alfabética)
//   const bottomSection = document.querySelector('section.lista-de-productos');

//   // Contenedor del grid (si quieres ocultar toda la parte visual del grid)
//   // OJO: aquí ocultamos el grid como tal; el buscador queda siempre visible arriba.
//   const gridWrapper = document.getElementById('productsGrid');

//   let activeLetter = 'all';

//   // function normalize(str){
//   //   return (str || '').toString().toLowerCase().trim();
//   // }

//   function normalize(str){
//     return (str || '')
//       .toString()
//       .toLowerCase()
//       .normalize('NFD')
//       .replace(/[\u0300-\u036f]/g, '')
//       .trim();
//   }

//   function toggleSections(isFiltering){
//     if (bottomSection) bottomSection.style.display = isFiltering ? 'none' : '';
//     if (gridWrapper) gridWrapper.style.display = isFiltering ? '' : 'none';

//     // Si no estás filtrando, limpia mensajes
//     if (!isFiltering){
//       resultsCount.textContent = '';
//       if (noResults) noResults.hidden = true;
//     }
//   }

//   function applyFilters(){
//     const q = normalize(input.value);
//     const isFiltering = (q.length > 0) || (activeLetter !== 'all');

//     toggleSections(isFiltering);

//     // Si no hay filtros, no hace falta tocar las cards
//     if (!isFiltering) return;

//     let visible = 0;

//     cards.forEach(card => {
//       const title = card.getAttribute('data-title') || '';
//       const terms = card.getAttribute('data-terms') || '';
//       const letter = card.getAttribute('data-letter') || '';

//       const matchLetter = (activeLetter === 'all') ? true : (letter === activeLetter);
//       const matchQuery = !q || title.includes(q) || terms.includes(q);

//       const show = matchLetter && matchQuery;
//       card.style.display = show ? '' : 'none';
//       if (show) visible++;
//     });

//     resultsCount.textContent = visible ? (visible + ' results') : '';
//     if (noResults) noResults.hidden = (visible !== 0);
//   }

//   // Search typing
//   // input.addEventListener('input', applyFilters);

//   input.addEventListener('input', function () {
//     const q = normalize(input.value);
  
//     // Si está escribiendo, resetear letra a "all"
//     if (q.length > 0 && activeLetter !== 'all') {
//       activeLetter = 'all';
//       azBtns.forEach(b => b.classList.toggle('is-active', b.dataset.letter === 'all'));
//     }
  
//     applyFilters();
//   });

//   // Clear
//   clearBtn.addEventListener('click', function(){
//     input.value = '';
//     input.focus();

//     // opcional: reset a "All" al limpiar
//     activeLetter = 'all';
//     azBtns.forEach(b => b.classList.toggle('is-active', b.dataset.letter === 'all'));

//     applyFilters();
//   });

//   // A-Z click
//   azBtns.forEach(btn => {
//     btn.addEventListener('click', function(){
//       azBtns.forEach(b => b.classList.remove('is-active'));
//       btn.classList.add('is-active');

//       activeLetter = btn.dataset.letter; // all / A..Z
//       applyFilters();
//     });
//   });

//   // Inicial:
//   // - No filtra
//   // - Oculta el grid
//   // - Muestra la sección inferior
//   applyFilters();
// })();


// ============================================
// Filtros de productos
// ============================================


(function(){
  const input = document.getElementById('productSearch');
  const clearBtn = document.getElementById('clearSearch');
  const azBtns = Array.from(document.querySelectorAll('.az-btn'));

  const grid = document.getElementById('productsGrid');
  const cards = Array.from(grid.querySelectorAll('.product-card'));

  const noResults = document.getElementById('noResults');
  const resultsCount = document.getElementById('resultsCount');

  const bottomSection = document.querySelector('section.lista-de-productos');
  const gridWrapper = document.getElementById('productsGrid');

  let activeLetter = 'todos';

  function normalize(str){
    return (str || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function toggleSections(isFiltering){
    if (bottomSection) bottomSection.style.display = isFiltering ? 'none' : '';
    if (gridWrapper) gridWrapper.style.display = isFiltering ? '' : 'none';

    if (!isFiltering){
      resultsCount.textContent = '';
      if (noResults) noResults.hidden = true;
    }
  }

  function applyFilters(){
    const q = normalize(input.value);
    const isFiltering = (q.length > 0) || (activeLetter !== 'todos');

    toggleSections(isFiltering);
    if (!isFiltering) return;

    let visible = 0;

    cards.forEach(card => {
      const title  = normalize(card.getAttribute('data-title'));
      const terms  = normalize(card.getAttribute('data-terms'));
      const letter = card.getAttribute('data-letter') || '';

      const matchLetter = (activeLetter === 'todos') ? true : (letter === activeLetter);
      const matchQuery  = !q || title.includes(q) || terms.includes(q);

      const show = matchLetter && matchQuery;
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    resultsCount.textContent = visible ? (visible + ' resultados') : '';
    if (noResults) noResults.hidden = (visible !== 0);
  }

  input.addEventListener('input', function () {
    const q = normalize(input.value);

    if (q.length > 0 && activeLetter !== 'todos') {
      activeLetter = 'todos';
      azBtns.forEach(b =>
        b.classList.toggle('is-active', b.dataset.letter === 'todos')
      );
    }

    applyFilters();
  });

  // clearBtn.addEventListener('click', function(){
  //   input.value = '';
  //   input.focus();

  //   activeLetter = 'all';
  //   azBtns.forEach(b =>
  //     b.classList.toggle('is-active', b.dataset.letter === 'all')
  //   );

  //   applyFilters();
  // });

  if (clearBtn) {
    clearBtn.addEventListener('click', function(){
      input.value = '';
      input.focus();
  
      activeLetter = 'todos';
      azBtns.forEach(b =>
        b.classList.toggle('is-active', b.dataset.letter === 'todos')
      );
  
      applyFilters();
    });
  }
  

  azBtns.forEach(btn => {
    btn.addEventListener('click', function(){
      azBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      activeLetter = btn.dataset.letter;
      applyFilters();
    });
  });

  applyFilters();
})();

// ============================================ Lista de productos alfabética